export const FETCH_JOBS_REQUEST = "FETCH_JOBS_REQUEST";
export const FETCH_JOBS = "FETCH_JOBS";
export const CREATE_JOBS_REQUEST = "CREATE_JOBS_REQUEST";
export const CREATE_JOBS = "CREATE_JOBS";
